import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Checkbox from "../../components/inputs/checkbox";
import { useDispatch } from "react-redux";
import LayoutPro from "./layoutPro";
import { create, get } from "../../services/services";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { toast, ToastContainer } from "react-toastify"; // Import toast
import "react-toastify/dist/ReactToastify.css"; // Import toast styles

function Paiement() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentLink, setPaymentLink] = useState(null); // State for payment link
  const [isLoading, setIsLoading] = useState(false); // State for loading
  const [isCopied, setIsCopied] = useState(false); // State for copy feedback
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  const plan = location.state.plan;
  const htAmount = parseFloat(plan?.discounted_price_eur);
  const vatRate = 0.2; // Adjust this based on your country's VAT rate
  const vatAmount = htAmount * vatRate;
  const ttcAmount = htAmount + vatAmount;
  const [savePaimentMethod, setSavePaimentMethod] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  
  const options = {
    clientSecret,
  };
  
  const createPaymentLink = () => {
    setIsLoading(true);
    create({plan_id: plan.id}, 'subscriptions/create-payment-link')
      .then((res) => {
        console.log({res});
        setPaymentLink(res.data?.payment_link_url || res?.payment_link_url);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la génération du lien de paiement");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const verifyPayment = () => {
    setIsLoading(true);
    get('subscription/status')
    .then((res) => {
      console.log(res);
      
      if (res.data?.has_active_subscription) {
        // Succès - abonnement actif
        toast.success("Paiement confirmé ! Redirection en cours...");
        
        // Redirection après un délai pour laisser voir le message
        setTimeout(() => {
          navigate("/confirmation");
        }, 2000);
      } else {
        // Échec - pas d'abonnement actif
        toast.error("Paiement non abouti. Veuillez réessayer.");
      }
    })
    .catch((err) => {
      console.error('Erreur de vérification: ', err);
      toast.error("Erreur lors de la vérification du paiement");
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  const copyToClipboard = () => {
    if (paymentLink) {
      navigator.clipboard.writeText(paymentLink)
        .then(() => {
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
          toast.success("Lien copié dans le presse-papier !");
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
          toast.error("Erreur lors de la copie du lien");
        });
    }
  };
  
  const fetchSecret = async () => {
    const data = { plan_id: plan.id, return_url: "/confirmation" };
    create(data, "subscription/plan")
      .then((res) => {
        setClientSecret(res?.data?.client_secret);
      })
      .catch((err) => {
        console.error(err);
        // toast.error("Erreur lors du chargement du système de paiement");
      });
  };
  
  const calculateDiscountPercentage = (originalPrice, discountedPrice) => {
    if (originalPrice <= 0 || discountedPrice <= 0) {
      return 0;
    }

    const discountAmount = originalPrice - discountedPrice;
    const discountPercentage = (discountAmount / originalPrice) * 100;

    return Math.round(discountPercentage * 100) / 100;
  };
  
  useEffect(() => {
    fetchSecret();
  }, []);

  return (
    <>
      <LayoutPro btn={false} currentStep={4} plan={plan}>
        <HelmetProvider>
          <Helmet>
            <title>Inscription Prestataire </title>
            <meta
              name="description"
              content="Inscription Prestataire étape paiement plan"
            />
          </Helmet>
        </HelmetProvider>
        
        {/* Toast Container */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        
        <div className="container">
          <div className=" mt-48">
            <h3 className="grey500">Paiement</h3>
            <div className="row">
              <div className="col-md-8">
                <div
                  style={{
                    minHeight: "400px",
                    width: "100%",
                    marginTop: "24px",
                  }}
                >
                  {clientSecret && (
                    <EmbeddedCheckoutProvider
                      stripe={stripePromise}
                      options={options}
                    >
                      <EmbeddedCheckout
                        style={{
                          width: "100%",
                          minWidth: "100%",
                          display: "block",
                        }}
                        className="StripeEmbeddedCheckout"
                      />
                    </EmbeddedCheckoutProvider>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="recap">
                  <h4 className="bg500">Récapitulatif</h4>
                  <div className="d-flex justify-content-between mt-16">
                    <p className="body bold500 bg500">
                      Business Pro - Plan {plan?.duration_in_months} mois
                    </p>
                    <p className="body bold500 bg500">
                      {parseFloat(plan?.default_price_eur)} €
                    </p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Traitement de cartes 0%</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Commission 0%</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">
                      Prise de rendez-vous illimitées
                    </p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Emplacements illimités</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">
                      Clients illimités et notification par e-mail
                    </p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66">Rapports illimités</p>
                    <p className="body grey66">0 €</p>
                  </div>
                  <div className="d-flex justify-content-between mt-24">
                    <p className="body bold500 green">
                      Remise sur le plan
                    </p>
                    <p className="body bold500 green">
                      -{" "}
                      {parseFloat(plan?.default_price_eur) -
                        parseFloat(plan?.discounted_price_eur)}{" "}
                      €
                    </p>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between ">
                    <p className="body grey500">
                      Total <span className="bold500">HT</span>{" "}
                    </p>
                    <p className="body grey500">
                      {plan?.discounted_price_eur} €
                    </p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <p className="body grey66 ">TVA</p>
                    <p className="body grey66">{vatAmount.toFixed(2)} €</p>
                  </div>
                  <div className="d-flex justify-content-between ">
                    <h5 className="body grey500">
                      {" "}
                      <span className="bold500">Total </span>TTC{" "}
                    </h5>
                    <h5 className="body grey500">{ttcAmount.toFixed(2)} €</h5>
                  </div>
                </div>
                <div className="card-twy mt-24">
                  <div className="mt-8">
                    {!paymentLink ? (
                      <button 
                        className="twyny-cta-primary w-100" 
                        onClick={createPaymentLink}
                        disabled={isLoading}
                      >
                        {isLoading ? "Génération du lien..." : "Payer par Lien"}
                      </button>
                    ) : (
                      <div className="payment-link-container">
                        <p className="body grey500 mb-8">Lien de paiement généré :</p>
                        <div className="d-flex align-items-center">
                          <a 
                            href={paymentLink} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="payment-link body grey66 flex-grow-1 text-break"
                          >
                            {paymentLink}
                          </a>
                          <button 
                            className="twyny-cta-secondary ml-8"
                            onClick={copyToClipboard}
                            title="Copier le lien"
                            disabled={isLoading}
                          >
                            {isCopied ? "✓ Copié" : "Copier"}
                          </button>
                        </div>
                        <div className="mt-16">
                          <button 
                            className="twyny-cta-primary w-100"
                            onClick={()=>verifyPayment()}
                            disabled={isLoading}
                            title="Vérifier le paiement et terminer"
                          >
                            {isLoading ? "Vérification en cours..." : "Vérifier le paiement"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ht-100"></div>
      </LayoutPro>
    </>
  );
}

export default Paiement;